import React, { useEffect, useRef } from 'react';
import './css/Learnings.css'; // Assuming you have a CSS file for additional styling

const Learnings = () => {
  const sectionsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    sectionsRef.current.forEach((section) => {
      if (section) {
        observer.observe(section);
      }
    });

    return () => {
      sectionsRef.current.forEach((section) => {
        if (section) {
          observer.unobserve(section);
        }
      });
    };
  }, []);

  return (
    <div className="learnings-container">
      <div className="card skill" ref={(el) => (sectionsRef.current[0] = el)}>
        <div className="card-body">
          <h2 className="card-title">AWS</h2>
          <div className="skill-sections">
            <div className="skill-section">
              <h3>Useful Links</h3>
              <ul>
                <li><a href="https://aws.amazon.com/documentation/">AWS Documentation</a></li>
                <li><a href="https://aws.amazon.com/training/">AWS Training</a></li>
                <li><a href="https://aws.amazon.com/blogs/">AWS Blogs</a></li>
              </ul>
            </div>
            <div className="skill-section">
              <h3>Important PDFs</h3>
              <ul>
                <li><a href="/path/to/aws-architecture.pdf" target="_blank" rel="noopener noreferrer">AWS Architecture PDF</a></li>
                <li><a href="/path/to/aws-security.pdf" target="_blank" rel="noopener noreferrer">AWS Security PDF</a></li>
              </ul>
            </div>
            <div className="skill-section">
              <h3>Videos</h3>
              <ul>
                <li><a href="https://www.youtube.com/watch?v=Ia-UEYYR44s" target="_blank" rel="noopener noreferrer">AWS Tutorial for Beginners</a></li>
                <li><a href="https://www.youtube.com/watch?v=6YkX5aFy9vI" target="_blank" rel="noopener noreferrer">AWS Certified Solutions Architect</a></li>
              </ul>
            </div>
            <div className="skill-section">
              <h3>Roadmap</h3>
              <ul>
                <li><a href="https://roadmap.sh/aws" target="_blank" rel="noopener noreferrer">AWS Roadmap</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      <div className="card skill" ref={(el) => (sectionsRef.current[1] = el)}>
        <div className="card-body">
          <h2 className="card-title">Kubernetes</h2>
          <div className="skill-sections">
            <div className="skill-section">
              <h3>Useful Links</h3>
              <ul>
                <li><a href="https://kubernetes.io/docs/">Kubernetes Documentation</a></li>
                <li><a href="https://kubernetes.io/training/">Kubernetes Training</a></li>
                <li><a href="https://kubernetes.io/blog/">Kubernetes Blogs</a></li>
              </ul>
            </div>
            <div className="skill-section">
              <h3>Important PDFs</h3>
              <ul>
                <li><a href="/path/to/kubernetes-architecture.pdf" target="_blank" rel="noopener noreferrer">Kubernetes Architecture PDF</a></li>
                <li><a href="/path/to/kubernetes-security.pdf" target="_blank" rel="noopener noreferrer">Kubernetes Security PDF</a></li>
              </ul>
            </div>
            <div className="skill-section">
              <h3>Videos</h3>
              <ul>
                <li><a href="https://www.youtube.com/watch?v=Ia-UEYYR44s" target="_blank" rel="noopener noreferrer">Kubernetes Tutorial for Beginners</a></li>
                <li><a href="https://www.youtube.com/watch?v=6YkX5aFy9vI" target="_blank" rel="noopener noreferrer">Kubernetes Certified Solutions Architect</a></li>
              </ul>
            </div>
            <div className="skill-section">
              <h3>Roadmap</h3>
              <ul>
                <li><a href="https://roadmap.sh/kubernetes" target="_blank" rel="noopener noreferrer">Kubernetes Roadmap</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      <div className="card skill" ref={(el) => (sectionsRef.current[2] = el)}>
        <div className="card-body">
          <h2 className="card-title">Python</h2>
          <div className="skill-sections">
            <div className="skill-section">
              <h3>Useful Links</h3>
              <ul>
                <li><a href="https://docs.python.org/3/">Python Documentation</a></li>
                <li><a href="https://www.python.org/about/gettingstarted/">Python Getting Started</a></li>
                <li><a href="https://realpython.com/">Real Python</a></li>
              </ul>
            </div>
            <div className="skill-section">
              <h3>Important PDFs</h3>
              <ul>
                <li><a href="/path/to/python-guide.pdf" target="_blank" rel="noopener noreferrer">Python Guide PDF</a></li>
                <li><a href="/path/to/python-best-practices.pdf" target="_blank" rel="noopener noreferrer">Python Best Practices PDF</a></li>
              </ul>
            </div>
            <div className="skill-section">
              <h3>Videos</h3>
              <ul>
                <li><a href="https://www.youtube.com/watch?v=rfscVS0vtbw" target="_blank" rel="noopener noreferrer">Python Tutorial for Beginners</a></li>
                <li><a href="https://www.youtube.com/watch?v=WGJJIrtnfpk" target="_blank" rel="noopener noreferrer">Python Advanced Tutorial</a></li>
              </ul>
            </div>
            <div className="skill-section">
              <h3>Roadmap</h3>
              <ul>
                <li><a href="https://roadmap.sh/python" target="_blank" rel="noopener noreferrer">Python Roadmap</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      <div className="card skill" ref={(el) => (sectionsRef.current[3] = el)}>
        <div className="card-body">
          <h2 className="card-title">Ansible</h2>
          <div className="skill-sections">
            <div className="skill-section">
              <h3>Useful Links</h3>
              <ul>
                <li><a href="https://docs.ansible.com/">Ansible Documentation</a></li>
                <li><a href="https://www.ansible.com/resources/webinars-training">Ansible Training</a></li>
                <li><a href="https://www.ansible.com/blog">Ansible Blogs</a></li>
              </ul>
            </div>
            <div className="skill-section">
              <h3>Important PDFs</h3>
              <ul>
                <li><a href="/path/to/ansible-guide.pdf" target="_blank" rel="noopener noreferrer">Ansible Guide PDF</a></li>
                <li><a href="/path/to/ansible-best-practices.pdf" target="_blank" rel="noopener noreferrer">Ansible Best Practices PDF</a></li>
              </ul>
            </div>
            <div className="skill-section">
              <h3>Videos</h3>
              <ul>
                <li><a href="https://www.youtube.com/watch?v=wgQ3rHtbmXI" target="_blank" rel="noopener noreferrer">Ansible Tutorial for Beginners</a></li>
                <li><a href="https://www.youtube.com/watch?v=iv1I7-4Zz7Y" target="_blank" rel="noopener noreferrer">Ansible Advanced Tutorial</a></li>
              </ul>
            </div>
            <div className="skill-section">
              <h3>Roadmap</h3>
              <ul>
                <li><a href="https://roadmap.sh/ansible" target="_blank" rel="noopener noreferrer">Ansible Roadmap</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Learnings;